var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 55,
    viewBox: "0 0 13 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75023 2.02488C8.73364 0.929565 9.6132 0.000231031 10.7251 0.000231031C11.8204 -0.0163646 12.7498 0.863185 12.7498 1.97509C12.7664 3.07041 11.8868 3.99977 10.7749 3.99977C9.67958 4.01636 8.75023 3.13679 8.75023 2.02488ZM11.4199 7.2301H9.91992V9.2301H11.4199V7.2301ZM11.4202 35.1602H9.92016V37.5602V38.1401C9.92016 38.3401 9.92016 38.5702 9.91016 38.8502L11.4102 38.8901C11.4102 38.7317 11.4131 38.5822 11.4158 38.4466C11.4181 38.334 11.4202 38.2309 11.4202 38.1401V37.5302V35.1701V35.1602ZM9.91992 12.9302H11.4199V16.6402H9.91992V12.9302ZM8.75 45.9302L10.17 46.4002C10.55 45.2602 10.85 44.0102 11.06 42.6802L9.58 42.4402C9.38 43.6902 9.1 44.8602 8.75 45.9202V45.9302ZM9.91992 27.7501H11.4199V31.4601H9.91992V27.7501ZM11.4199 20.3401H9.91992V24.0501H11.4199V20.3401ZM5.81043 52.8101L4.94043 51.5901C5.82043 50.9701 6.60043 50.1301 7.26043 49.1101L8.52043 49.9201C7.75043 51.1001 6.84043 52.0701 5.81043 52.8101ZM0 53.0702V54.5602C0.74 54.5602 1.46 54.4901 2.13 54.3701L1.85 52.9001C1.27 53.0101 0.64 53.0702 0 53.0702Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerJ);
export default __webpack_public_path__ + "static/media/LOWER_J.6aa1fd7801136bffab1f5cbdba912da1.svg";
export { ForwardRef as ReactComponent };